import { useCallback, useState } from "react";

export function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return stored === null ? initialValue : JSON.parse(stored);
    } catch (error) {
      return initialValue;
    }
  });

  const setStoredValue = useCallback(
    (nextValue) => {
      setValue((currentValue) => {
        const resolved =
          typeof nextValue === "function" ? nextValue(currentValue) : nextValue;
        window.localStorage.setItem(key, JSON.stringify(resolved));
        return resolved;
      });
    },
    [key]
  );

  return [value, setStoredValue];
}
